import { SecondaryColors } from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    seeButton: {
      color: SecondaryColors.base.default,
      height: Spacings.s24,
    },
    categories: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      rowGap: Spacings.s16,
      [BreakPointsMedia.SM]: {
        marginTop: Spacings.s12,
        marginBottom: Spacings.s12,
      },
      [BreakPointsMedia.XS]: {
        marginTop: Spacings.s12,
        marginBottom: Spacings.s12,
      },
      [BreakPointsMedia.XXS]: {
        marginTop: Spacings.s12,
        marginBottom: Spacings.s12,
      },
    },
    textContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      rowGap: Spacings.s12,
      columnGap: Spacings.s12,
    },
    relevantCategoriesButton: {
      textTransform: 'capitalize',
    },
  },
  {
    name: 'relevant-categories',
  },
);

export default useStyles;
